import {
  donutCriteria,
  rainbowCriteria,
  btmSubmitData,
  bookingChangeCriteria
} from './definition'

export default {
  [donutCriteria] (state, value) {
    state.donutCriteria = value
  },
  [rainbowCriteria] (state, value) {
    state.rainbowCriteria = value
  },
  [btmSubmitData] (state, value) {
    state.btmSubmitData = value
  },
  [bookingChangeCriteria] (state, value) {
    state.bookingChangeCriteria = value
  }
}



// WEBPACK FOOTER //
// ./src/components/booking/store/mutations.js